import { Component, OnInit, Output, EventEmitter, Input, OnChanges, ViewChild } from '@angular/core';
import { VarType } from '../expression-var-grid/vartype';
import { ExpressionEventService } from '../utils/expression-event-service';
import { DatagridComponent } from '@farris/ui-datagrid';
import { ExpressionEditorLocalePipe } from '../utils/expression-editor-locale.pipe';
import { VarEntity } from '../common/ExpressEntity';

@Component({
  selector: 'app-expression-var-info-grid',
  templateUrl: './expression-var-info-grid.component.html',
  styleUrls: ['./expression-var-info-grid.component.css']
})
export class ExpressionVarInfoGridComponent implements OnInit, OnChanges {

  //定义i18n标识
  private localeId: string;
  private localePipe: ExpressionEditorLocalePipe;

  constructor(private eventService: ExpressionEventService) {
    //初始化i18n标识
    this.localeId = localStorage.getItem('languageCode') || 'zh-CHS';
    this.localePipe = new ExpressionEditorLocalePipe(this.localeId);
    this.columns = [
      { field: 'key', title: this.localePipe.transform("VariableName"), width: '20%', filter: true },
      { field: 'name', title: this.localePipe.transform("VariableSemanticNameValue"), width: '30%', filter: true }
    ];
  }
  @ViewChild('dg') dg: DatagridComponent;
  @Input() currentVarType: VarType = VarType.Session;
  @Input() elements: any;
  @Input() contextEntities: VarEntity[] = [];
  @Input() sessionEntities: VarEntity[] = [];
  @Output() selectVarInfoRow = new EventEmitter();
  @Output() dbclickInsert = new EventEmitter();
  items: VarEntity[] = []
  columns = [];
  ngOnInit() {
    this.eventService.subClearVarSelect().subscribe();
  }
  ngOnChanges(): void {
    this.eventService.subClearVarSelect().subscribe();
    if (this.elements != null && this.elements.length == 0) {
      this.items = [];
    } else {
      switch (this.currentVarType) {
        case VarType.Context:
          this.items = this.contextEntities;
          break;
        case VarType.Session:
          this.items = this.sessionEntities;
          break;
      }
    }
  }

  ondblclickRow($event) {
    this.dbclickInsert.emit($event.rowData);
  }
  selectRowChange($event) {
    this.selectVarInfoRow.emit($event.data);
  }
}
